import { centsToFormattedDollars } from '@fruitful/fruitils';
import { BodyMediumRegular, View, XStack, YStack } from 'smoothie';

import {
    type Transaction,
    TransactionDcSign,
} from '../../../banking/types/Transactions';
import { TransactionItem } from '../../../home/components/free-to-spend/TransactionsSheet';

const signedTransactionAmountCents = (transaction: Transaction): number => {
    return (
        transaction.amount *
        (transaction.dcSign === TransactionDcSign.DEBIT.toLowerCase() ? 1 : -1)
    );
};

interface TransactionGroupBoxProps {
    header: string;
    transactions: Transaction[];
    /** When omitted, transaction rows are not pressable. */
    onOpenTransaction?: (transaction: Transaction) => void;
    /** When false, omit per-row date subtitles. Defaults to true. */
    showDateSubtitle?: boolean;
}

/**
 * Sprout chat transaction group — header + total + rows.
 * Unlike FTS DayBox, the header is a plain string (day-formatted or custom label).
 */
export const TransactionGroupBox = ({
    header,
    transactions,
    onOpenTransaction,
    showDateSubtitle = true,
}: TransactionGroupBoxProps) => {
    const groupTotal = transactions.reduce(
        (acc, transaction) => acc + signedTransactionAmountCents(transaction),
        0,
    );

    return (
        <YStack borderRadius={24} overflow="hidden">
            <XStack
                padding={16}
                backgroundColor="$gray200"
                justifyContent="space-between"
                alignItems="center"
            >
                <BodyMediumRegular>{header}</BodyMediumRegular>
                <BodyMediumRegular>
                    {centsToFormattedDollars(groupTotal, groupTotal > 0)}
                </BodyMediumRegular>
            </XStack>
            <View padding={16} backgroundColor="$gray100">
                {transactions.length === 0 ? (
                    <BodyMediumRegular paddingVertical={8} textAlign="center">
                        No transactions
                    </BodyMediumRegular>
                ) : (
                    <YStack gap={24}>
                        {transactions.map((transaction) => (
                            <TransactionItem
                                key={transaction.uuid}
                                transaction={transaction}
                                onOpenTransaction={onOpenTransaction}
                                showDateSubtitle={showDateSubtitle}
                            />
                        ))}
                    </YStack>
                )}
            </View>
        </YStack>
    );
};
